import { debugTurbolinks, turbolinksInstalled, turbolinksSupported, turboInstalled, turbolinksVersion5, } from "./turbolinksUtils.js";
const pageLoadedCallbacks = new Set();
const pageUnloadedCallbacks = new Set();
let currentPageState = 'initial';
function runPageLoadedCallbacks() {
    currentPageState = 'load';
    pageLoadedCallbacks.forEach((callback) => {
        void callback();
    });
}
function runPageUnloadedCallbacks() {
    currentPageState = 'unload';
    pageUnloadedCallbacks.forEach((callback) => {
        void callback();
    });
}
function setupPageNavigationListeners() {
    // Install listeners when running on the client (browser).
    // We must check for navigation libraries AFTER the document is loaded because we load the
    // Webpack bundles first.
    const hasNavigationLibrary = (turbolinksInstalled() && turbolinksSupported()) || turboInstalled();
    if (!hasNavigationLibrary) {
        debugTurbolinks('NO NAVIGATION LIBRARY: running page loaded callbacks immediately');
        runPageLoadedCallbacks();
        return;
    }
    if (turboInstalled()) {
        debugTurbolinks('TURBO DETECTED: adding event listeners for turbo:before-render and turbo:render.');
        document.addEventListener('turbo:before-render', runPageUnloadedCallbacks);
        document.addEventListener('turbo:render', runPageLoadedCallbacks);
        runPageLoadedCallbacks();
    }
    else if (turbolinksVersion5()) {
        debugTurbolinks('TURBOLINKS 5 DETECTED: adding event listeners for turbolinks:before-render and turbolinks:render.');
        document.addEventListener('turbolinks:before-render', runPageUnloadedCallbacks);
        document.addEventListener('turbolinks:render', runPageLoadedCallbacks);
        runPageLoadedCallbacks();
    }
    else {
        debugTurbolinks('TURBOLINKS 2 DETECTED: adding event listeners for page:before-unload and page:change.');
        document.addEventListener('page:before-unload', runPageUnloadedCallbacks);
        document.addEventListener('page:change', runPageLoadedCallbacks);
    }
}
let isPageLifecycleInitialized = false;
function initializePageEventListeners() {
    if (typeof window === 'undefined')
        return;
    if (isPageLifecycleInitialized) {
        return;
    }
    isPageLifecycleInitialized = true;
    if (document.readyState !== 'loading') {
        setupPageNavigationListeners();
    }
    else {
        document.addEventListener('DOMContentLoaded', setupPageNavigationListeners);
    }
}
export function onPageLoaded(callback) {
    if (currentPageState === 'load') {
        void callback();
    }
    pageLoadedCallbacks.add(callback);
    initializePageEventListeners();
}
export function onPageUnloaded(callback) {
    if (currentPageState === 'unload') {
        void callback();
    }
    pageUnloadedCallbacks.add(callback);
    initializePageEventListeners();
}
